import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Mail } from 'lucide-react';
import { authApi } from '@watchparty/shared';
import { Input } from '@/components/ui/Input';
import { Label } from '@/components/ui/Label';
import { Button } from '@/components/ui/Button';
export function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    async function handleSubmit(e) {
        e.preventDefault();
        if (!email.trim())
            return;
        setIsSubmitting(true);
        try {
            await authApi.forgotPassword(email.trim());
        }
        catch {
            // Always show success to prevent user enumeration
        }
        setSubmitted(true);
        setIsSubmitting(false);
    }
    return (_jsx("div", { style: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--color-bg)',
            padding: '24px',
        }, children: _jsx("div", { style: {
                width: '100%',
                maxWidth: '420px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
            }, children: !submitted ? (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                            width: '56px', height: '56px', borderRadius: 'var(--radius-full)',
                            background: 'var(--color-surface-raised)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }, children: _jsx(Mail, { size: 28, style: { color: 'var(--color-accent)' } }) }), _jsx("h1", { style: { fontFamily: 'var(--font-family-heading)', fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-text)' }, children: "Forgot your password?" }), _jsx("p", { style: { fontFamily: 'var(--font-family-body)', fontSize: '0.9375rem', color: 'var(--color-text-muted)', lineHeight: 1.6 }, children: "Enter your email address and we'll send you a link to reset your password." }), _jsxs("form", { onSubmit: handleSubmit, style: { width: '100%', display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '8px', textAlign: 'left' }, children: [_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '6px' }, children: [_jsx(Label, { htmlFor: "email", children: "Email" }), _jsx(Input, { id: "email", type: "email", placeholder: "you@example.com", value: email, onChange: (e) => setEmail(e.target.value), autoComplete: "email", autoFocus: true })] }), _jsx(Button, { type: "submit", variant: "default", disabled: isSubmitting || !email.trim(), style: {
                                    width: '100%',
                                    background: 'var(--color-accent)',
                                    color: 'var(--color-text-inverse)',
                                }, children: isSubmitting ? 'Sending...' : 'Send Reset Link' })] }), _jsx(Link, { to: "/", style: {
                            marginTop: '4px',
                            fontFamily: 'var(--font-family-body)',
                            fontSize: '0.875rem',
                            color: 'var(--color-text-muted)',
                            textDecoration: 'none',
                        }, children: "\u2190 Back to sign in" })] })) : (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                            width: '56px', height: '56px', borderRadius: 'var(--radius-full)',
                            background: 'var(--color-surface-raised)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }, children: _jsx(Mail, { size: 28, style: { color: 'var(--color-accent)' } }) }), _jsx("h1", { style: { fontFamily: 'var(--font-family-heading)', fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-text)' }, children: "Check your email" }), _jsxs("p", { style: { fontFamily: 'var(--font-family-body)', fontSize: '0.9375rem', color: 'var(--color-text-muted)', lineHeight: 1.6 }, children: ["If an account exists for ", _jsx("strong", { style: { color: 'var(--color-text)' }, children: email }), ", we've sent a password reset link."] }), _jsx("p", { style: { fontFamily: 'var(--font-family-body)', fontSize: '0.8125rem', color: 'var(--color-text-faint)', lineHeight: 1.5 }, children: "The link will expire in 24 hours. Check your spam folder if you don't see it." }), _jsx(Link, { to: "/", style: {
                            display: 'inline-block',
                            marginTop: '8px',
                            padding: '10px 24px',
                            background: 'var(--color-accent)',
                            color: 'var(--color-text-inverse)',
                            textDecoration: 'none',
                            borderRadius: 'var(--radius-md)',
                            fontFamily: 'var(--font-family-body)',
                            fontSize: '0.9375rem',
                            fontWeight: 600,
                        }, children: "Back to Sign In" })] })) }) }));
}
